/* tslint:disable */
/* eslint-disable */

/**
 * Which attachment scope to include in the zip. One scope maps to
 * exactly one `InvoiceAttachmentTypeId`: `original-invoice` → 1,
 * `original-invoice-attachment` → 2, `invoice` → 6,
 * `final-report` → 4 (the Final Report / lopputilitysraportti
 * produced at final settlement). Watermarked variants are
 * deliberately excluded.
 */
export enum ClientInvoiceExportScope {
  OriginalInvoice = 'original-invoice',
  OriginalInvoiceAttachment = 'original-invoice-attachment',
  Invoice = 'invoice',
  FinalReport = 'final-report'
}
